module.exports = __webpack_public_path__ + "img/icon_bszn.71c8234f.png";